export { default as Bottle } from './Bottle';
export { default as Droplet } from './Droplet';
export { default as Shower } from './Shower';
export { default as Sink } from './Sink';


// WEBPACK FOOTER //
// ./src/icons/index.js